@if (isVisible) {
  <div
    class="modal-backdrop"
    [class]="configSafe.additionalClass"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-main-text"
  >
    <div class="modal-container">
      <!-- Close (×) button -->
      @if (configSafe.defaultCloseButton) {
        <button
          class="modal-close-btn"
          aria-label="Close modal"
          (click)="onClose()"
        >
          &times;
        </button>
      }

      <!-- Main text (supports HTML via innerHTML) -->
      @if (configSafe.mainText) {
        <div
          id="modal-main-text"
          class="modal-main-text"
          [innerHTML]="configSafe.mainText"
        ></div>
      }

      <!-- Modal actions layout -->
      <div class="modal-actions" [ngClass]="isStacked ? 'modal-actions--stacked' : 'modal-actions--inline'">
        <button
          class="btn btn--reject"
          (click)="onReject()"
          [hidden]="!configSafe.rejectText"
        >
          {{ configSafe.rejectText }}
        </button>
        <button
          class="btn btn--confirm"
          (click)="onConfirm()"
          [hidden]="!configSafe.confirmText"
        >
          {{ configSafe.confirmText }}
        </button>
      </div>
    </div>
  </div>
}
